import {LunarYear} from '../../LunarYear'
import moment from 'moment-timezone'

const Y1939 = new LunarYear(
  moment.tz('1939-02-19 00:00', 'Asia/Seoul'),
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  [30, 30, 29, 29, 30, 29, 29, 30, 29, 30, 29, 30],
)

export default Y1939
